<div class="page-header">
  <h3 class="page-title ">
    <span class="tbtext-clr"> Orders </span>
    <span class="text-white">
      <i class="fa fa-angle-right text-white" aria-hidden="true"></i> Orders
    </span>
  </h3>
</div>
<div class="col-lg-12 p-0 grid-margin stretch-card" *ngIf="Orders.length>0">
  <div class="card">
    <div class="card-body">

      <div class="table-responsive">
        <table class="table table-sm row-border hover " datatable [dtOptions]="dtOptions">
          <thead>
            <tr>
              <!--<th class="text-center">
                S.No
              </th>-->
              <th class="text-center">
                Order<br /> ID
              </th>
              <th class="text-center">
                Customer<br /> Name
              </th>
              <th class="text-center">
                Customer<br /> Contact
              </th>
              <th class="text-center">
                Order<br /> Date
              </th>
              <th class="text-center">
                Delivery<br /> Type
              </th>
              <th class="text-center">
                Delivery<br /> Agent
              </th>
              <th class="text-center">
                Delivery<br /> Contact
              </th>
              <th class="text-center">
                Tracking<br /> Number
              </th>
              <th class="text-center">
                Order<br /> Status
              </th>
              <th class="text-center">
                Assign<br /> Order
              </th>
              <th class="text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of Orders;let i = index" class="text-center">
              <!--<td class="py-1">
                {{ i+1 }}
              </td>-->
              <td>
                {{ order.orderId }}
              </td>
              <td>
                {{ order.userAddresses?.name }}
              </td>
              <td>
                {{ order.userAddresses?.mobileNumber }}
              </td>
              <td>
                {{ order.orderPlacedOn | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{ order?.assignOrder?.deliveryType }}
              </td>
              <td>
                {{ order?.assignOrder?.delivaryAgent }}
              </td>
              <td>
                {{ order?.assignOrder?.deliveryMobileNo }}
              </td>
              <td>
                {{ order?.assignOrder?.trackingNumber }}
              </td>
              <td>
                <button class="cursor-cm" [ngClass]="{
                  'text-success':order.transationStatusId === 6,
                  'text-return':order.transationStatusId === 7,
                  'text-secondary':order.transationStatusId === 3,
                  'text-danger':order.transationStatusId === 2,
                  'text-info':order.transationStatusId === 4,
                  'text-orderout':order.transationStatusId === 5,
                  'text-placed':order.transationStatusId === 1
                }"> 
                  {{ order?.transationStatus }}</button>
              </td>
              <td class="text-center">
                <div *ngIf="order.assignOrder; else assignOrder">
                  <img src="assets/images/assign-order.svg" class="green-tick" alt="">
                </div>
                <ng-template #assignOrder>
                  <button class="btn-mcred" (click)="setAssignOrder(order)"> Set </button>
                </ng-template>
              </td>
              <td>
                <div class="actions">
                  <a *ngIf="order.hideEdit" (click)="editAssignOrder(order)">
                    <i class="mdi mdi-pencil-box text-white"></i>
                  </a>
                  <a (click)="viewdetails(order)">
                    <i class="mdi mdi-eye tbtext-clr"></i>
                  </a>
                </div>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="Orders.length==0 && !isLoading" style="margin-top: 25%;">
  <div class="col-md-12">
    <p class="text-info text-center">No Orders found.</p>
  </div>
</div>

